import '@babel/polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import {createStore, applyMiddleware, compose} from 'redux';
import reduxThunk from 'redux-thunk';
import {Provider} from 'react-redux';
import reducers from "./services/reducers";
import html5backend from 'react-dnd-html5-backend';
import {DndProvider} from "react-dnd";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/fonts/fa47/css/font-awesome.min.css';
import './assets/css/sata/sata.css';

const canUseReduxExtension = process.env.REACT_APP_ENVIRONMENT === 'dev' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composeEnhancers = canUseReduxExtension ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const reduxStore = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));

ReactDOM.render(
    <Provider store={reduxStore}>
        <DndProvider backend={html5backend}>
            <App/>
        </DndProvider>
    </Provider>,
    document.getElementById('root-search-widget')
);

// If you want your APP to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
/*serviceWorker.register({
    onUpdate: () => {
        //Some UI notification comes here, then reload
        window.location.reload();
    }
});*/
